const formReducer = (state, action) => {
  switch (action.type) {
    case 'store': {
      return {
        ...state,
        formData: { ...state.formData, ...action.payload.formData },
      };
    }
    case 'step-change': {
      return {
        ...state,
        stepNumber: action.payload,
      };
    }
    case 'reset': {
      return {
        ...state,
        stepNumber: 0,
        isCompleted: false,
        isLoading: false,
        formData: action.payload,
      };
    }
    default:
      console.error('formReducer reached the default case!');
  }
};

export default formReducer;
